module.exports = "/_next/static/images/f8663c872a1382ee149c993e8451a31c-payment_modal.png";